/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PaginatedResponseWithErrorGeneric } from '../shared/paginated-response-with-error-generic';
import { GetPaginatedCasesResponseJson } from './get-paginated-cases-response-json';
import { GetCasesResult } from '../results/get-cases-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { PaginatedListGeneric } from '../shared/paginated-list-generic';
import { ClearanceCaseSummaryDto } from '../models/clearance-case-summary-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetPaginatedCasesResponse extends PaginatedResponseWithErrorGeneric<GetPaginatedCasesResponseJson, GetCasesResult> implements IResponseWithErrorGeneric<GetCasesResult> {
  public cases: PaginatedListGeneric<ClearanceCaseSummaryDto>;
  public countCreated: number = undefined;
  public countRegistered: number = undefined;
  public countWaiting: number = undefined;
  public countUnread: number = undefined;
  public countProcessing: number = undefined;
  public countUninvoiced: number = undefined;

  //<custom-body>
  public clearanceCases: ClearanceCaseSummaryDto[];

  constructor(response: HttpResponse<GetPaginatedCasesResponse>) {
    super(response, GetCasesResult.Error);
    if (this.result !== GetCasesResult.Success) {
      return;
    }

    this.cases = this.body.cases;
    this.countCreated = this.body.countCreated;
    this.countRegistered = this.body.countRegistered;
    this.countWaiting = this.body.countWaiting;
    this.countUnread = this.body.countUnread;
    this.countProcessing = this.body.countProcessing;
    this.countUninvoiced = this.body.countUninvoiced;
  }
  //</custom-body>
}
